export default "__VITE_ASSET__AWLszB28__"